import { Link } from "@inertiajs/react";
import { ArrowRightAlt } from "@mui/icons-material";
import { Box, Stack, useTheme } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

import { formatPrice } from "../../lib/format";
import { type Compensation } from "../../types/Compensation";
import Body from "../theme/Body";
import Button from "../theme/Button";
import Heading from "../theme/Heading";

import CompensationQuote from "./CompensationQuote";
import PaymentButton from "./PaymentButton";

const Compensation = ({
  clamp,
  compensation,
  global,
  refreshList,
}: {
  compensation: Compensation;
  clamp?: boolean;
  global?: boolean;
  refreshList: () => void;
}) => {
  const { description, eventId, eventName, from, price, to, userName } =
    compensation;
  const theme = useTheme();
  const inlineTheme = theme.name === "inline";

  return (
    <Card className="compensation-card" sx={{ marginBottom: "1em" }}>
      <CardContent
        className="compensation-card-content"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "calc(100% - 2.5em)",
          gap: "1em",
        }}
      >
        <Box>
          <Stack
            className="compensation-header"
            direction="row"
            justifyContent="space-between"
          >
            <Heading
              className="compensation-name"
              component="h4"
              sx={{ margin: 0 }}
              variant="h3"
            >
              {userName}
            </Heading>
            <Body className="compensation-price" component="div" variant="h3">
              {formatPrice(price)}
            </Body>
          </Stack>
          <Body
            className="compensation-trip"
            color={inlineTheme ? undefined : "primary.main"}
            sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
            variant="h4"
          >
            {from} <ArrowRightAlt /> {to}
          </Body>
          {global && (
            <Button
              className="compensation-event"
              component={Link}
              href={`/events/${eventId}`}
              sx={{ marginLeft: "-8px" }}
            >
              <Body color="black">{eventName}</Body>
            </Button>
          )}
        </Box>
        <CompensationQuote
          clamp={clamp}
          quote={description}
          userName={userName}
        />
        <Box className="compensation-footer">
          <Stack
            alignItems="center"
            className="compensation-payment-options"
            direction="row"
            gap="0.5em"
            overflow="auto"
          >
            <PaymentButton
              compensation={compensation}
              refreshList={refreshList}
            />
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Compensation;
